@if (hasIssues) {
  <div class="validation-banner">
    <div class="validation-banner__header" (click)="toggleExpanded()">
      <div class="validation-banner__header-left">
        <mat-icon class="validation-banner__icon">warning</mat-icon>
        <span class="validation-banner__title">
          {{ issues.length }} {{ (issues.length === 1 ? 'unresolved placeholder' : 'unresolved placeholders') | translate }}
        </span>
      </div>
      <mat-icon class="validation-banner__toggle">{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </div>
    <div class="validation-banner__hint">{{ 'These fields will not render correctly.' | translate }}</div>
    @if (isExpanded) {
      <div class="validation-banner__list">
        @for (issue of issues; track trackByPath($index, issue)) {
          <div class="validation-banner__item">
            <mat-icon class="validation-banner__item-icon">error_outline</mat-icon>
            <span class="validation-banner__item-text">{{ issueLabels.get(issue.path + '::' + issue.reason) }}</span>
          </div>
        }
      </div>
    }
  </div>
}
